module.exports = __webpack_public_path__ + "5ced81e4.png";